module.exports = __webpack_public_path__ + "img/content_2.0cff5e58.png";